import React, { Fragment } from "react";

import { Tooltip } from "../../../../components/tooltip/Tooltip";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";

interface OriginalUrlProps {
  url?: string;
}

export const OriginalUrl = ({ url }: OriginalUrlProps) => {
  if (!url) {
    return <Fragment>-</Fragment>;
  }

  return (
    <div className="drilldowns__table__original-url">
      <Mobile>
        <span>{url}</span>
      </Mobile>
      <NotMobile>
        <Tooltip placement="top-start" autoWidth content={<span>{url}</span>}>
          <span>{url}</span>
        </Tooltip>
      </NotMobile>
    </div>
  );
};
